import { register, getPrefix } from '../../../Utils'

/* toggleItems ruckeln bei hover, das könnte noch optimiert werden */

const StickyNavigation = el => {
  const prefix = getPrefix(el)
  const level1 = el.querySelector(`.${prefix}level-1-wrapper`)
  const level1Height = level1.offsetHeight
  const level2 = el.querySelector(`.${prefix}level-2-wrapper`)
  const toggleItems = level1.querySelectorAll(`.${prefix}link.${prefix}has--children`)
  const linkItems = level1.querySelectorAll(`.${prefix}link.${prefix}has--no-children`)
  const targetItems = level2.querySelectorAll(`.${prefix}level-2-item`)
  const scrollIndicator = el.querySelector(`.${prefix}scroll-indicator`)
  const corporateHeader = document.querySelector(`[data-component="CorporateHeader"]`)
  const headerPrefix = corporateHeader ? corporateHeader.dataset.prefix : ''
  const stickyContainer = el.querySelector(`.${prefix}sticky-container`)
  const stickyPlaceholder = el.querySelector(`.${prefix}sticky-placeholder`)

  let level2Width = level2.offsetWidth
  let activeScrollContainer
  let originalPosition = el.offsetTop
  let headerHeight = 0

  stickyPlaceholder.style.height = `${level1Height}px`

  const resizeWindow = () => {
    level2Width = level2.offsetWidth
  }

  const toggleScrollIndicator = (scrollContainer) => {
    if (activeScrollContainer) {
      activeScrollContainer.removeEventListener('scroll', scrollChild)
    }

    if (scrollContainer.scrollWidth > level2Width) {
      scrollIndicator.classList.add(`${prefix}active`)
      scrollContainer.scrollLeft = 0
      scrollContainer.addEventListener('scroll', scrollChild)
      activeScrollContainer = scrollContainer
    } else {
      scrollIndicator.classList.remove(`${prefix}active`)
    }
  }

  const scrollChild = (e) => {
    scrollIndicator.classList.toggle(`${prefix}hidden`, e.target.scrollLeft > 5)
  }

  const toggleChild = (e) => {
    e.stopPropagation()

    const targetId = e.currentTarget.dataset.id
    const targetElement = level2.querySelector(`[data-id='${targetId}']`)

    toggleScrollIndicator(targetElement)

    toggleItems.forEach(linkItem => {
      linkItem.classList.toggle(`${prefix}active`, targetId === linkItem.dataset.id)
    })

    targetItems.forEach(targetItem => {
      targetItem.classList.toggle(`${prefix}active`, targetId === targetItem.dataset.id)
    })
  }

  toggleItems.forEach(toggleItem => {
    toggleItem.addEventListener('mouseenter', toggleChild)
  })

  const touchToggler = e => {
    if (!e.currentTarget.classList.contains(`${prefix}active`)) {
      e.preventDefault()
      toggleChild(e)
    }
  }

  toggleItems.forEach(toggleItem => {
    toggleItem.addEventListener('touchstart', touchToggler)
  })

  const closeAllChildren = (e) => {
    e.stopPropagation()

    toggleItems.forEach(linkItem => {
      linkItem.classList.remove(`${prefix}active`)
    })

    targetItems.forEach(targetItem => {
      targetItem.classList.remove(`${prefix}active`)
    })
  }

  linkItems.forEach(linkItem => {
    linkItem.addEventListener('mouseenter', closeAllChildren)
  })

  el.addEventListener('mouseleave', closeAllChildren)

  window.addEventListener('resize', resizeWindow)

  const windowScroll = () => {
    headerHeight = corporateHeader.offsetHeight
    if (originalPosition < window.pageYOffset + (corporateHeader && !corporateHeader.classList.contains(`${headerPrefix}is--hidden`) ? headerHeight : 0)) {
      el.classList.toggle(`${prefix}is--sticky`, true)
      if (corporateHeader && !corporateHeader.classList.contains(`${headerPrefix}is--hidden`)) {
        stickyContainer.style.transform = `translateY(${headerHeight}px)`
      } else {
        stickyContainer.style.transform = `translateY(0)`
      }
    } else {
      el.classList.toggle(`${prefix}is--sticky`, false)
      stickyContainer.style.transform = `translateY(0)`
    }
  }

  window.addEventListener('scroll', windowScroll)
  // window.addEventListener('hashchange', () => {
  //   window.setTimeout(() => {
  //     windowScroll()
  //   }, 100)
  // })
}

register('StickyNavigation', StickyNavigation)
